export default "__VITE_ASSET__kLRCwgcX__"